 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"calendar-calendar-module":"calendar-calendar-module","common":"common","taskboard-ngrx-taskboard-ngrx-module":"taskboard-ngrx-taskboard-ngrx-module","taskboard-taskboard-module":"taskboard-taskboard-module","default~add-promotions-add-promotions-module~compartir-compartir-module~components-ui-components-mod~973285e2":"default~add-promotions-add-promotions-module~compartir-compartir-module~components-ui-components-mod~973285e2","ui-kit-ui-kit-module":"ui-kit-ui-kit-module","default~cards-cards-module~charts-charts-module":"default~cards-cards-module~charts-charts-module","cards-cards-module":"cards-cards-module","default~categories-categories-module~clients-clients-module~compartir-compartir-module~components-ui~09bd714a":"default~categories-categories-module~clients-clients-module~compartir-compartir-module~components-ui~09bd714a","categories-categories-module":"categories-categories-module","default~add-promotions-add-promotions-module~clients-clients-module~compartir-compartir-module~compo~5f2f06d1":"default~add-promotions-add-promotions-module~clients-clients-module~compartir-compartir-module~compo~5f2f06d1","default~chat-chat-module~chat-ngrx-chat-ngrx-module~components-ui-components-module":"default~chat-chat-module~chat-ngrx-chat-ngrx-module~components-ui-components-module","default~components-ui-components-module~tabs-order-tabs-order-module~tabs-reservation-order-tabs-res~48a3c722":"default~components-ui-components-module~tabs-order-tabs-order-module~tabs-reservation-order-tabs-res~48a3c722","components-ui-components-module":"components-ui-components-module","order-order-module":"order-order-module","reservation-order-reservation-order-module":"reservation-order-reservation-order-module","stores-stores-module":"stores-stores-module","default~category-products-category-products-module~configuration-configuration-module~create-categor~d0789d84":"default~category-products-category-products-module~configuration-configuration-module~create-categor~d0789d84","default~charts-charts-module~clients-clients-module~compartir-compartir-module~configuration-configu~228cf16d":"default~charts-charts-module~clients-clients-module~compartir-compartir-module~configuration-configu~228cf16d","default~compartir-compartir-module~configuration-configuration-module~data-tables-data-tables-module~8b870174":"default~compartir-compartir-module~configuration-configuration-module~data-tables-data-tables-module~8b870174","default~charts-charts-module~compartir-compartir-module~configuration-configuration-module~dashboard~541f8e38":"default~charts-charts-module~compartir-compartir-module~configuration-configuration-module~dashboard~541f8e38","default~configuration-configuration-module~forms-forms-module~inbox-inbox-module~promotions-promotio~7d54bcd5":"default~configuration-configuration-module~forms-forms-module~inbox-inbox-module~promotions-promotio~7d54bcd5","configuration-configuration-module":"configuration-configuration-module","default~forms-forms-module~promotions-promotions-module~support-support-module~users-users-module":"default~forms-forms-module~promotions-promotions-module~support-support-module~users-users-module","support-support-module":"support-support-module","default~forms-forms-module~promotions-promotions-module~users-users-module":"default~forms-forms-module~promotions-promotions-module~users-users-module","promotions-promotions-module":"promotions-promotions-module","reports-reports-module":"reports-reports-module","forms-forms-module":"forms-forms-module","customer-customer-module":"customer-customer-module","clients-clients-module":"clients-clients-module","compartir-compartir-module":"compartir-compartir-module","reservations-reservation-module":"reservations-reservation-module","pages-full-pages-full-pages-module":"pages-full-pages-full-pages-module","products-products-module":"products-products-module","social-commerce-social-commerce":"social-commerce-social-commerce","default~charts-charts-module~detail-products-detail-products-module~pages-content-pages-content-page~028a8be8":"default~charts-charts-module~detail-products-detail-products-module~pages-content-pages-content-page~028a8be8","default~charts-charts-module~tabs-reports-tabs-reports-module":"default~charts-charts-module~tabs-reports-tabs-reports-module","default~charts-charts-module~dashboard-dashboard-module":"default~charts-charts-module~dashboard-dashboard-module","charts-charts-module":"charts-charts-module","dashboard-dashboard-module":"dashboard-dashboard-module","pages-content-pages-content-pages-module":"pages-content-pages-content-pages-module","chat-chat-module":"chat-chat-module","chat-ngrx-chat-ngrx-module":"chat-ngrx-chat-ngrx-module","data-tables-data-tables-module":"data-tables-data-tables-module","inbox-inbox-module":"inbox-inbox-module","firebase-auth":"firebase-auth","maps-maps-module":"maps-maps-module","tables-tables-module":"tables-tables-module","create-category-create-category-module":"create-category-create-category-module","create-subcategory-create-subcategory-module":"create-subcategory-create-subcategory-module","tabs-category-tabs-category-module":"tabs-category-tabs-category-module","detail-category-detail-category-module":"detail-category-detail-category-module","detail-order-detail-order-module":"detail-order-detail-order-module","tabs-order-tabs-order-module":"tabs-order-tabs-order-module","detail-reservation-order-detail-reservation-order-module":"detail-reservation-order-detail-reservation-order-module","tabs-reservation-order-tabs-reservation-order-module":"tabs-reservation-order-tabs-reservation-order-module","create-stores-create-stores-module":"create-stores-create-stores-module","detail-stores-detail-stores-module":"detail-stores-detail-stores-module","my-update-store-my-update-store-module":"my-update-store-my-update-store-module","users-users-module":"users-users-module","tabs-stores-tabs-stores-module":"tabs-stores-tabs-stores-module","update-store-update-store-module":"update-store-update-store-module","create-promotions-create-promotions-module":"create-promotions-create-promotions-module","add-promotions-add-promotions-module":"add-promotions-add-promotions-module","detail-promotion-detail-promotion-module":"detail-promotion-detail-promotion-module","tabs-promotions-tabs-promotions-module":"tabs-promotions-tabs-promotions-module","tabs-reports-tabs-reports-module":"tabs-reports-tabs-reports-module","detail-customer-detail-customer-module":"detail-customer-detail-customer-module","tabs-customer-tabs-customer-module":"tabs-customer-tabs-customer-module","knowledge-base-knowledge-base-module":"knowledge-base-knowledge-base-module","category-products-category-products-module":"category-products-category-products-module","create-products-create-products-module":"create-products-create-products-module","tabs-products-tabs-products-module":"tabs-products-tabs-products-module","detail-products-detail-products-module":"detail-products-detail-products-module","social-facebook-social-facebook-module":"social-facebook-social-facebook-module","social-instagram-social-instagram-module":"social-instagram-social-instagram-module","social-whatsapp-social-whatsapp-module":"social-whatsapp-social-whatsapp-module","create-users-create-users-module":"create-users-create-users-module","tabs-users-tabs-users-module":"tabs-users-tabs-users-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
